let globalState = {
    allTranslations: {},
    fetchedLangApps: [],
    isDevEnvironment: false
};
let listeners = [];
export const resolveLangApp = (lang, app) => `${lang}:${app}`;
export const GSStore = {
    read() {
        return globalState;
    },
    subscribe(listener) {
        listeners = [...listeners, listener];
        return () => {
            listeners = listeners.filter((l) => l !== listener);
            if (!listeners.length && globalState.isDevEnvironment) {
                GSStore.reset();
            }
        };
    },
    update() {
        listeners.forEach((updateState) => updateState());
    },
    reset() {
        const wasDevEnvironment = globalState.isDevEnvironment;
        globalState = {
            allTranslations: {},
            fetchedLangApps: [],
            isDevEnvironment: wasDevEnvironment
        };
    }
};
export const mergeAllTranslations = (lang, translations, isDevEnvironment) => {
    const mergeTranslationsInProvidedApps = () => {
        const result = {};
        Object.keys(translations || {}).forEach((app) => {
            var _a;
            result[app] = {
                ...(((_a = globalState.allTranslations[lang]) === null || _a === void 0 ? void 0 : _a[app]) || {}),
                ...translations[app]
            };
        });
        return result;
    };
    const newState = {
        ...globalState,
        allTranslations: {
            ...globalState.allTranslations,
            [lang]: {
                ...(globalState.allTranslations[lang] || {}),
                ...mergeTranslationsInProvidedApps()
            }
        },
        isDevEnvironment
    };
    if (JSON.stringify(newState) !== JSON.stringify(globalState)) {
        globalState = newState;
        GSStore.update();
    }
    return globalState.allTranslations.lang;
};
export const mergeFetchedUrls = (lang, app, apps) => {
    const newApps = [];
    newApps.push(resolveLangApp(lang, app));
    apps === null || apps === void 0 ? void 0 : apps.map((appName) => newApps.push(resolveLangApp(lang, appName)));
    if (!newApps.every((langApp) => globalState.fetchedLangApps.includes(langApp))) {
        globalState = {
            ...globalState,
            fetchedLangApps: [...globalState.fetchedLangApps, ...newApps]
        };
        GSStore.update();
    }
    return globalState.fetchedLangApps;
};
